<div
  [class.expanded]="open && options?.length && showOptionsWrapper"
  [class.disabled]="isDisabled"
  [class.top]="openToTop"
  class="select-wrapper"
  tabindex="0"
  [style.width]="width"
  #select
>
  <div
    class="select-input {{ isDisabled ? 'disabled' : '' }} p-8 d-flex align-items-center justify-content-space-between base-border-radius full-height gap-8"
    (click)="toggleDropdown()"
  >
    <div class="select-items w-0 flex-grow-1">
      <input
        class="full-width text-overflow-ellipsis"
        [placeholder]="placeholder || ''"
        [disabled]="isDisabled"
        readonly
        [value]="displayText"
        autocomplete="off"
      >
    </div>
    <button class="toggle-icon" type="button">
      <i class="ri-arrow-drop-down-line icon-sm2 c-t-blue-700"></i>
    </button>
  </div>

  <ng-template #optionsWrapperTemplate>
    <div
      [style.width]="select.offsetWidth + 'px'"
      class="options-wrapper
      {{ openToTop ? 'options-wrapper--top' : '' }}
      {{ showOptionsWrapper ? '' : 'visibility-hidden pointer-events-none' }}
      "
      #optionWrapper
    >
      <ul class="options-wrapper__list" [style.max-height]="height">
        @if (hasResetOption) {
          <li
            class="list-option"
            (click)="selectOption(null)"
          >
            <span>—</span>
          </li>
        }

        @for (option of options; track option.id) {
          <li
            class="
              list-option
              {{ option.isSelected ? 'selected' : '' }}
              {{ option.isSelected && !canUnselect ? 'option-disabled': '' }}
            "
            tabindex="0"
            (click)="option.isSelected && !canUnselect ? null : selectOption($any(option.id))"
          >
            <span>{{ option.name }}</span>
          </li>
        }
      </ul>
    </div>
  </ng-template>
</div>
